import { render, staticRenderFns } from "./serviceBox.vue?vue&type=template&id=c9cd9c90&scoped=true"
import script from "./serviceBox.vue?vue&type=script&lang=js"
export * from "./serviceBox.vue?vue&type=script&lang=js"
import style0 from "./serviceBox.vue?vue&type=style&index=0&id=c9cd9c90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9cd9c90",
  null
  
)

export default component.exports